export default __webpack_public_path__ + "static/fun-sig-8669362bc70a9a19fc2978172e9aefbb.jpg";